import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { CommonService } from 'src/app/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-user-manual',
  templateUrl: './user-manual.component.html',
  styleUrls: ['./user-manual.component.css']
})
export class UserManualComponent extends BaseComponent implements OnInit {
  languageList: any = [{id: 1, name: 'English'}];
  languageId:any=1;
  lable:'';
  mId:any;
  smId:any;
  sId:any;
  htmlContent:any

  constructor(private activatedRoute: ActivatedRoute, CommonService: CommonService, toastr: ToastrService, private route: Router, private active: ActivatedRoute,) {
    super(CommonService, toastr);
  }

  ngOnInit(): void {
    this.lable = this.activatedRoute.snapshot.params['lable'];
    this.mId = this.activatedRoute.snapshot.params['menuid'];
    this.smId = this.activatedRoute.snapshot.params['submenuid'];
    this.sId = this.activatedRoute.snapshot.params['screenid'];
      this.getUserManual(this.mId, this.smId, this.sId)
      this.route.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.lable = this.activatedRoute.snapshot.params['lable'];
          this.mId = this.activatedRoute.snapshot.params['menuid'];
          this.smId = this.activatedRoute.snapshot.params['submenuid'];
          this.sId = this.activatedRoute.snapshot.params['screenid'];
          // this.mId = this.activatedRoute.snapshot.params['mid'];
          this.languageId='1';
          if (location.href.includes('/HOME/um/'))
            this.getUserManual(this.mId, this.smId, this.sId)
        }
      });
  }

  getUserManual(mId:any, smId:any, sId:any){//UserGuideMapping/GetMenuUserGuideMapping
    this.htmlContent= '';
    this.activeSpinner();
    this.CommonService.postCall(`UserGuideMapping/GetMenuUserGuideMapping`, {
      "MENU_ID": mId ?? 0,
      "SUB_MENU_ID": smId ?? 0,
      "SCREEN_ID": sId ?? 0,
      "LANGUAGE_ID": 1
    }).subscribe((res: any) => {
      if(res == null || res.length==0){
        this.toastr.info(res?.message);
      }
      else{
        this.htmlContent = res?.data?.HTML_CONTENT;
        // this.toastr.info(res?.message);

      }
      this.deactivateSpinner();
    }, e => {
      this.deactivateSpinner();

    })
    
  }

}
